import { Alert } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSurvey } from '@/hooks/app';
import { Flex, LoadingSpin, PageContainer } from '@/components';
import { SurveyApiType } from '@/configs';
import SurveysList from './SurveysList';

export function SurveysPage() {

  const [t] = useTranslation(['common', 'survey']);
  const { surveys, fetchSurvey, loading } = useSurvey();
  const type = SurveyApiType.Survey;

  useEffect(() => {
    fetchSurvey();
  }, []);

  const surveyItems = surveys?.filter((survey) => survey.type === type) ?? [];
  const hasSurveys = surveyItems.length > 0;

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  if (!hasSurveys) {
    return (
      <PageContainer title={t(`common:labels.survey-${type}`)}>
        <Alert type="warning" className="flex mx-auto max-h-16 mt-2 text-center" message={t(`common:messages.survey-empty-${type}`)} />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={t(`common:labels.survey-${type}`)}>
      <Flex direction="column" className="max-w-xl mx-auto">
        <SurveysList
          surveys={surveyItems}
          onIgnore={() => { }}
          showIgnore={false}
          extraSpace
        />
      </Flex>
    </PageContainer>
  );
}

export default SurveysPage;
